// @ts-strict-ignore
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    standalone: false
})
export class BadgeComponent {
  @Input() style: { [klass: string]: any } = {};
  @Input() text: string;
}
